import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_URL, NAV_LINKS } from "@/data/content";
import { Button } from "@/components/ui/button";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl border-b border-slate-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-20 lg:h-24 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2"
        >
          <img
            src={LOGO_URL}
            alt="C2 Advertising"
            className="h-12 lg:h-14 w-auto"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              onClick={() => goTo(l.href)}
              className="text-sm font-medium text-slate-700 hover:text-magenta transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Button
            data-testid="nav-cta-button"
            onClick={() => goTo("#contact")}
            className="hidden sm:inline-flex rounded-full bg-magenta hover:bg-[#C2185B] text-white px-5 h-10 font-semibold"
          >
            Hai să vorbim
          </Button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden h-10 w-10 grid place-items-center rounded-full border border-slate-200"
            aria-label="Meniu"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t border-slate-200 bg-white"
        >
          <div className="px-5 py-4 flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                onClick={() => goTo(l.href)}
                className="text-left py-2 text-base font-medium text-slate-800"
              >
                {l.label}
              </button>
            ))}
            <Button
              onClick={() => goTo("#contact")}
              className="rounded-full bg-magenta hover:bg-[#C2185B] text-white"
            >
              Hai să vorbim
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
